
    <div class="logo-gif">
      <img alt="loading" src="../../../assets/shared/img/logo_allya.gif">
    </div>
  